import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=6206f9f6&"
import script from "./Restaurant.vue?vue&type=script&lang=js&"
export * from "./Restaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports